// extracted by mini-css-extract-plugin
export var bounce = "Header-module--bounce--95466";
export var dotMoveLeft = "Header-module--dot-move-left--13af7";
export var dotMoveRight = "Header-module--dot-move-right--5d13b";
export var gradient = "Header-module--gradient--135ac";
export var header = "Header-module--header--2a9cb";
export var separatorWidth = "Header-module--separator-width--52997";